import { colors } from '@insurancemenu/imenu-components-lib';
import { CheckCircle, InfoButtonFilled } from '@insurancemenu/imenu-components-lib/dist/icons';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { MedicalConditionStatus } from 'store/modules/subscriber-imq/types';
import { ConditionTagStyled, ConditionTextStyled } from './styles';

interface Props {
  status: MedicalConditionStatus;
  className?: string;
}

const ICONS_MAP = {
  [MedicalConditionStatus.DETAILS_MISSING]: <InfoButtonFilled width="2.4rem" color={colors.red[600]} />,
  [MedicalConditionStatus.COMPLETED]: <CheckCircle width="2.4rem" color={colors.green[600]} />,
};

const LABEL_MAP = {
  [MedicalConditionStatus.DETAILS_MISSING]: 'Details Missing',
  [MedicalConditionStatus.COMPLETED]: 'Completed',
};

export const MedicalConditionStatusTag: React.FC<Props> = observer(({ status, className }) => {
  return (
    <ConditionTagStyled className={className}>
      {ICONS_MAP[status]}
      <ConditionTextStyled $status={status}>{LABEL_MAP[status]}</ConditionTextStyled>
    </ConditionTagStyled>
  );
});
